var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-body',[_c('app-table-row',[_c('app-table-cell',{attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }